import { useEffect } from 'react';
import {
  ToastProvider, ToastViewport, Toast, ToastClose,
  ToastTitle, ToastDescription, ToastIcon,
} from '@/components/ui/toast';
import { useToastState } from '@/hooks/useToast';

export const Toaster = () => {
  const { toasts, subscribe } = useToastState();

  useEffect(() => {
    const unsub = subscribe();
    return unsub;
  }, [subscribe]);

  return (
    <ToastProvider>
      {toasts.map(t => (
        <Toast key={t.id} variant={t.variant}>
          <ToastIcon variant={t.variant || 'default'} />
          <div className="flex-1">
            <ToastTitle>{t.title}</ToastTitle>
            {t.description && <ToastDescription>{t.description}</ToastDescription>}
          </div>
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport />
    </ToastProvider>
  );
};
